import React from "react";
import { FeatureFlag } from "@rentablo/theming";
import { useFeatureFlag } from "@hooks";
import { MenuItem, MenuItemProps } from "./MenuItem";

interface Props extends MenuItemProps {
  featureFlag: FeatureFlag;
}
export const FeatureFlagMenuItem = ({ featureFlag, ...props }: Props) => {
  const isFlagEnabled = useFeatureFlag(featureFlag);

  if (!isFlagEnabled) {
    return null;
  }

  return <MenuItem {...props} />;
};
